








































































import Vue from 'vue'
import FullModalLayout from '@/components/modal/basics/FullModal/FullModalLayout.vue'
import FullModalHeaderCloseButton from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderCloseButton.vue'
import FullModalHeaderTitle from '@/components/modal/basics/FullModal/FullModalHeader/FullModalHeaderTitle.vue'
import SelectButton from '@/components/modal/basics/SelectButton.vue'
import { Activity } from '@/core/Activities'

export default Vue.extend({
  components: {
    FullModalLayout,
    FullModalHeaderCloseButton,
    FullModalHeaderTitle,
    SelectButton,
  },
  props: {
    name: {
      type: String as () => string,
      default: 'ActivityModal',
    },
    activityIds: {
      type: Array as () => number[],
      required: true,
    },
    activities: {
      type: Array as () => Activity[],
      default: [],
    },
  },
  data() {
    return {
      innerActivityIds: [] as number[],
    }
  },
  computed: {
    isAllChecked(): boolean {
      return this.activities.every(({ id }) =>
        this.innerActivityIds.includes(id)
      )
    },
  },
  methods: {
    getCheckIconByBool(checked: boolean): string {
      return checked ? 'checkbox' : 'checkbox_null'
    },
    isChecked(id: number): boolean {
      return this.innerActivityIds.includes(id)
    },
    checkAll(): void {
      if (!this.isAllChecked) {
        this.innerActivityIds = this.activities.map(({ id }) => Number(id))
      } else {
        this.innerActivityIds = []
      }
    },
    beforeOpen(): void {
      // 親からの値を入れる
      if (this.activityIds) {
        this.innerActivityIds = this.activityIds
      }
    },
    onSubmit(): void {
      this.$emit('submit', this.innerActivityIds)
      this.$modal.pop()
    },
  },
})
